"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_ID_ADMINISTRATOR = exports.CLIENT_SECRET_ADMINISTRATOR = exports.CLIENT_ID_COLLABORATOR = exports.CLIENT_ID_PATIENT = exports.CLIENT_SECRET = exports.SCOPE = exports.GRANT_TYPE = void 0;
exports.GRANT_TYPE = "password";
exports.SCOPE = "Solimat";
exports.CLIENT_SECRET = "622294388H062g0q27XZw91O5r9AS0719f6ih43J";
exports.CLIENT_ID_PATIENT = "public-spa-client-resource-owner-password";
exports.CLIENT_ID_COLLABORATOR = "public-spa-collaborator-resource-owner-password";
exports.CLIENT_SECRET_ADMINISTRATOR = "8da11220039af784fbf719cb5a1dcb7e";
exports.CLIENT_ID_ADMINISTRATOR = "private-spa-administrator-resource-owner-password";
